// ** Initial State
import {dataUtils} from "../../../applyoo/js/dataUtils";
import {Dictionary} from "../../../applyoo/model/IDictionary";
import {cloneDeep} from 'lodash'
import {executeApplyooComponentsFunction, setPageData} from "../../../applyoo/infrastructure/useApplyooComponent";
import {callPostService} from "../../../applyoo/services/api_service";
import {store} from "../../storeConfig/store";

const initialState = {
    getDataResponseObj: {},
    data: {},
    originalData: {},
    lstValidationErrors: [],
    dicValidationErrorsByElement: {},
    lstActions: [],
    lstModals: {},
    isDataLoaded: false,
    dicResponseExtData: {},
    isNewRow: false,
    primaryEntityID: null,
    // lstFiles: [],
    // lstOriginalFiles:[],
    dicLastResponseObj: {},
    dicPagingByResponseObj: {},
    dicCustomFlags: {globalDashboard_selectedDashboard: -1, isUserDataArrived: false},
    //pageState:null,
    //pageStateQueries:[],

}

const resolveSetSingleRow = (prmData, prmResponseName, prmDicQueryEntityHierarchy) => {
    let currLstQueryEntityHierarchy = prmDicQueryEntityHierarchy; //prmDicQueryEntityHierarchy[prmResponseName];

    //if (!!currLstQueryEntityHierarchy && currLstQueryEntityHierarchy.length > 0) {

        let firstQueryEntityHierarchy = prmDicQueryEntityHierarchy; //currLstQueryEntityHierarchy[0];

        if (firstQueryEntityHierarchy?.QueryResponseObj?.IsSingleRow) {

            let currDsData = prmData[prmResponseName];

            let currDtData = currDsData[firstQueryEntityHierarchy.EntityName];

            if (!!currDtData && currDtData.length > 0) {

                currDsData[firstQueryEntityHierarchy.EntityName] = currDtData[0];
            } else {

                currDsData[firstQueryEntityHierarchy.EntityName] = {};
            }
        }
    //}

    return prmData;
}

const createHierarchyStructureFromFlatStructure = (prmPrimaryMetaDataObj, prmFlatData) => {
    let outObj = {};

    //for (let ind01 = 0; ind01 < prmArrEntitesMetaData.length; ind01++) {

    let currPrimaryMetaDataObj = prmPrimaryMetaDataObj; //prmArrEntitesMetaData[ind01];

    let currArrPrimaryEntityData = prmFlatData[currPrimaryMetaDataObj.EntityName];

    if (!!currArrPrimaryEntityData) {

        outObj[currPrimaryMetaDataObj.EntityName] = currArrPrimaryEntityData;

        if (!!currPrimaryMetaDataObj.QueryResponseObj.LstChildren
            && currPrimaryMetaDataObj.QueryResponseObj.LstChildren.length > 0) {

            for (let ind02 = 0; ind02 < currArrPrimaryEntityData.length; ind02++) {

                let currPrimaryRecord = currArrPrimaryEntityData[ind02];

                let currPrimaryRecordKeyValue = currPrimaryRecord[currPrimaryMetaDataObj.KeyField];

                for (let ind03 = 0; ind03 < currPrimaryMetaDataObj.QueryResponseObj.LstChildren.length; ind03++) {

                    let currChildMetaDataObj = currPrimaryMetaDataObj.QueryResponseObj.LstChildren[ind03];

                    let currArrChildEntityData = prmFlatData[currChildMetaDataObj.EntityName];

                    if (!!currArrChildEntityData) {

                        currPrimaryRecord[currChildMetaDataObj.EntityName] = [];

                        for (let ind04 = 0; ind04 < currArrChildEntityData.length; ind04++) {

                            let currChildRecord = currArrChildEntityData[ind04];

                            //if (currChildRecord[currChildMetaDataObj.SubEntityKeyField] == currPrimaryRecordKeyValue) {
                            if (currChildRecord[currChildMetaDataObj.SubEntityKeyField] == currPrimaryRecord[currChildMetaDataObj.ParentEntityKeyField]) {
                                currPrimaryRecord[currChildMetaDataObj.EntityName].push(currChildRecord);
                            }

                            if (currChildMetaDataObj.hasOwnProperty('SubEntityKeyField2')
                                && currChildRecord[currChildMetaDataObj.SubEntityKeyField2] == currPrimaryRecord[currChildMetaDataObj.ParentEntityKeyField]) {
                                currPrimaryRecord[currChildMetaDataObj.EntityName].push(currChildRecord);
                            }

                        }
                    }
                }
            }


            for (let ind02 = 0; ind02 < currPrimaryMetaDataObj.QueryResponseObj.LstChildren.length; ind02++) {

                let currChildMetaDataObj = currPrimaryMetaDataObj.QueryResponseObj.LstChildren[ind02];

                createHierarchyStructureFromFlatStructure(currChildMetaDataObj, prmFlatData)
            }
        }
    }

    //}

    return outObj;
}

const createFlatStructureFromHierarchyStructure = (prmPrimaryMetaDataObj, prmHierarchyData) => {

    let outObj = {};

    //Comment: for each EntitesMetaData
    //for (let ind01 = 0; ind01 < prmArrEntitesMetaData.length; ind01++) {

    let currPrimaryMetaDataObj = prmPrimaryMetaDataObj; //prmArrEntitesMetaData[ind01];

    //Comment: get primary DataTable from hierarchy data structure
    let currArrPrimaryEntityData = prmHierarchyData[currPrimaryMetaDataObj.EntityName];

    if (!!currArrPrimaryEntityData) {

        //Comment: set primary DataTable in the out Object at that table name property
        outObj[currPrimaryMetaDataObj.EntityName] = currArrPrimaryEntityData;

        //Comment: handle chlidren
        if (!!currPrimaryMetaDataObj.QueryResponseObj.LstChildren
            && currPrimaryMetaDataObj.QueryResponseObj.LstChildren.length > 0) {

            //Comment: for each row in current table
            for (let ind02 = 0; ind02 < currArrPrimaryEntityData.length; ind02++) {

                let currPrimaryRecord = currArrPrimaryEntityData[ind02];

                let currPrimaryRecordKeyValue = currPrimaryRecord[currPrimaryMetaDataObj.KeyField];

                //for each child table of the current DataTable
                for (let ind03 = 0; ind03 < currPrimaryMetaDataObj.QueryResponseObj.LstChildren.length; ind03++) {

                    let currChildMetaDataObj = currPrimaryMetaDataObj.QueryResponseObj.LstChildren[ind03];

                    if (!!currPrimaryRecord[currChildMetaDataObj.EntityName]) {

                        let currArrChildEntityData = currPrimaryRecord[currChildMetaDataObj.EntityName];

                        if (!!currArrChildEntityData) {

                            //Comment: Set primary key value to its children.
                            for (let ind04 = 0; ind04 < currArrChildEntityData.length; ind04++) {

                                let currChildRecord = currArrChildEntityData[ind04];

                                currChildRecord[currChildMetaDataObj.SubEntityKeyField] = currPrimaryRecord[currChildMetaDataObj.ParentEntityKeyField];

                                //currChildRecord[currChildMetaDataObj.SubEntityKeyField] = currPrimaryRecordKeyValue;
                            }


                            if (!outObj[currChildMetaDataObj.EntityName]) {

                                outObj[currChildMetaDataObj.EntityName] = [];
                            }

                            outObj[currChildMetaDataObj.EntityName] = outObj[currChildMetaDataObj.EntityName].concat(currPrimaryRecord[currChildMetaDataObj.EntityName]);

                            //Comment: remove child table refrence
                            currPrimaryRecord[currChildMetaDataObj.EntityName] = null;
                            delete currPrimaryRecord[currChildMetaDataObj.EntityName];


                            if (!!currChildMetaDataObj.QueryResponseObj.LstChildren && currChildMetaDataObj.QueryResponseObj.LstChildren.length > 0) {

                                for (let ind04 = 0; ind04 < currArrChildEntityData.length; ind04++) {

                                    let currChildRecord = currArrChildEntityData[ind04];

                                    let resultsObj = createFlatStructureFromHierarchyStructure(currChildMetaDataObj.QueryResponseObj.LstChildren, currChildRecord);

                                    if (!!resultsObj) {

                                        for (let currTableName in resultsObj) {

                                            if (!outObj[currTableName]) {

                                                outObj[currTableName] = [];
                                            }

                                            outObj[currTableName] = outObj[currTableName].concat(resultsObj[currTableName]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }


            }


        }
    }
    //}

    return outObj;

}

export const convertToHierarchyData = (prmData, prmDataStructure, prmResponseName) => {

    let outObj = {
        dicResponseData: {},
        convertedToHierarchyData: {},
        primaryEntityID: null,
        isNewRow: false,
        responseName: '',
    }

    //for (let currResponseName in prmData) {
        outObj.responseName = prmResponseName

        let currResponseDataObj = {
            ResponseName: prmResponseName,
        };

        outObj.dicResponseData[prmResponseName] = currResponseDataObj;

        let currLstQueryEntityHierarchy = prmDataStructure; //prmResponseObj.DicQueryEntityHierarchy[currResponseName];

        if (!!currLstQueryEntityHierarchy) {

            currResponseDataObj.LstQueryEntityHierarchy = currLstQueryEntityHierarchy;

            //comment: convert flat structure to Hierarchy Structure
            //let currFlatData = prmData[prmDataStructure.EntityName];

            let currHierarchyData = createHierarchyStructureFromFlatStructure(currLstQueryEntityHierarchy, prmData);

            outObj.convertedToHierarchyData[prmResponseName] = currHierarchyData;

            //prmResponseObj.Data[currResponseName]._FlatData = currFlatData;

            currResponseDataObj.originalResponseData = dataUtils.clone(currHierarchyData);

            if (!!currLstQueryEntityHierarchy?.QueryResponseObj?.IsSingleRow) {

                if (currHierarchyData[currLstQueryEntityHierarchy?.EntityName].length > 0) {

                    outObj.primaryEntityID = currHierarchyData[currLstQueryEntityHierarchy?.EntityName][0][currLstQueryEntityHierarchy?.KeyField]
                } else {

                    outObj.primaryEntityID = 0;
                    outObj.isNewRow = true;
                    //APPLYOO.internals.raiseEvent(APPLYOO.globals.eventTypes.newDataRow.EventCode, currResponseDataObj);

                    let primaryEntityName = currLstQueryEntityHierarchy?.EntityName;
                    let dataBindTableStr = prmResponseName + "." + primaryEntityName;

                    let newEntityDefaultParams = {
                        DataConnectionCode: currLstQueryEntityHierarchy?.DataConnectionCode,
                        EntityName: primaryEntityName,
                        DataBindStr: dataBindTableStr,
                    };

                    //TODO!!!
                    //APPLYOO.config.Actions["action_AP_GetEntityDefaultValues"].Execute(newEntityDefaultParams);

                    //APPLYOO.services.getEntityDefaultsValues(APPLYOO.selectedProject.selectedProjectID, primaryEntityName, getEntityDefaultsValues_Callback);

                    //function getEntityDefaultsValues_Callback(prmResponse) {
                    //    //console.debug(currLstQueryEntityHierarchy[0].EntityName);
                    //    console.debug(primaryEntityName);

                    //    console.debug(prmResponse.DicDefaultValues);// prmResponse.DicDefaultValues[currCol.field]
                    //}
                }

                let triggerParams = {
                    ValueSource: 'IsNewRow'
                }

                //TODO!!!
                //APPLYOO.selectedPage.checkPageTriggers('parameter', triggerParams);
            }


            outObj.convertedToHierarchyData = resolveSetSingleRow(outObj.convertedToHierarchyData, prmResponseName, prmDataStructure);
        }
        else {

            if (!!prmResponseName && !!prmData && !!prmData[prmResponseName]){
                outObj.convertedToHierarchyData[prmResponseName] = prmData[prmResponseName];
            }
            else if (!!prmResponseName) {
                outObj.convertedToHierarchyData[prmResponseName] = prmData;
            }

            if (!!prmData && !!prmResponseName) {
                currResponseDataObj.originalResponseData = dataUtils.clone(prmData[prmResponseName]);
            }

            if (!!prmDataStructure
                && !!prmResponseObj.DicRelatedDataRequests
                && !!prmResponseName
                && !!prmResponseObj?.DicRelatedDataRequests[prmResponseName]?.StoreProcedure_IsSingleRow) {

                let convertedDataToSingleRows = {};

                let currDsData = outObj.convertedToHierarchyData[prmResponseName];

                let newDsData = {};

                for (let currTableName in currDsData) {

                    let currDtData = currDsData[currTableName];

                    if (!!currDtData && currDtData.length > 0) {

                        newDsData[currTableName] = currDtData[0];
                    } else {

                        newDsData[currTableName] = {};
                    }
                }

                outObj.convertedToHierarchyData[prmResponseName] = newDsData;
            }
        }
    //}

    return outObj;
};

const groupValidationErrorsByElement = (prmLstValidationErrors) => {
    let dicOut = {};

    if (!!prmLstValidationErrors) {
        for (let ind01 = 0; ind01 < prmLstValidationErrors.length; ind01++) {
            let currValidationError = prmLstValidationErrors[ind01];

            if (!dicOut[currValidationError.ElementGuid]) {
                dicOut[currValidationError.ElementGuid] = [];
            }

            dicOut[currValidationError.ElementGuid].push(currValidationError);
        }
    }

    return dicOut;
}

const mergeQueryFiles = (prmQueryCode, prmLstCurrStateFiles, prmLstFiles, prmMergeType) => {
    let lstOut = prmLstCurrStateFiles || []
    let lstActionFiles = prmLstFiles


    if (prmMergeType === 'addOrUpdate') {
        for (const currFileObj of lstActionFiles) {
            if (!!currFileObj.ID) {
                let foundObj = lstOut.find((prmItem) => prmItem.ID == currFileObj.ID)

                if (!!foundObj) {
                    for (const currKey in currFileObj) {
                        foundObj[currKey] = currFileObj[currKey]
                    }
                }
                else {
                    lstOut.push(cloneDeep(currFileObj))
                }
            }
            else {
                lstOut.push(cloneDeep(currFileObj))
            }
        }
    }
    else if (prmMergeType === 'delete') {
        for (const currFileObj of lstActionFiles) {
            if (!!currFileObj.ID) {
                let foundObj = lstOut.find((prmItem) => prmItem.ID == currFileObj.ID)

                if (!!foundObj) {
                    let currIndex = lstOut.indexOf(foundObj)

                    if (currIndex > -1) {
                        lstOut.splice(currIndex,1)
                    }
                }
            }
            else {
                lstOut.push(cloneDeep(currFileObj))
            }
        }
    }

    return lstOut
}

export const store_PageData = (state = initialState, action) => {
    switch (action.type) {
        case 'FREE_MEMORY':
            return {...state, initialState};

        case 'CHANGE_LST_ELEMENTS':
            return {...initialState}

        // case 'SET_PAGE_STATE':
        //     //let data =cloneDeep(state.data);
        //     // let data = JSON.parse(JSON.stringify(state.data));
        //     //dataUtils.setNestedJsonValue(data, action.dataKey, action.value, true);
        //     //data[action.dataKey][action.elementKey] = action.data
        //
        //     return {...state, pageState: action.pageState, pageStateQueries: action.lstQueryNames}

        case 'MERGE_HIERARCHY_DATA':
            let newHierarchyData =  action.newHierarchyData //[action.queryEntityHierarchy.ResponseName]

            let newDataAfterMerge = {...state.data}
            let newOrigDataAfterMerge = {...state.originalData}

            for (const currTableName in newHierarchyData) {
                if (!!newHierarchyData[currTableName]) {
                    let lstCurrTabData = newHierarchyData[currTableName]

                    if (!!newDataAfterMerge
                        && !!newDataAfterMerge[action.responseName]
                        && !!newDataAfterMerge[action.responseName][currTableName]) {
                        let lstPrevData = newDataAfterMerge[action.responseName][currTableName]
                        let lstPrevOrigData = newOrigDataAfterMerge[action.responseName][currTableName]
                        let lstRemoveRowsOfMissingKeys = []

                        if (!!action.removeRowsOfMissingKeysStr) {
                            lstRemoveRowsOfMissingKeys = action.removeRowsOfMissingKeysStr.split(",")
                        }

                        newDataAfterMerge[action.responseName][currTableName] = dataUtils.mergeArrays(lstPrevData,lstCurrTabData, action.queryEntityHierarchy.KeyField)
                        newOrigDataAfterMerge[action.responseName][currTableName] = cloneDeep(dataUtils.mergeArrays(lstPrevOrigData,lstCurrTabData, action.queryEntityHierarchy.KeyField))

                        newDataAfterMerge[action.responseName][currTableName] = newDataAfterMerge[action.responseName][currTableName].filter((prmItem) => {
                            return prmItem[action.queryEntityHierarchy.KeyField] > 0
                        })

                        if (!!newOrigDataAfterMerge[action.responseName][currTableName]) {
                            newOrigDataAfterMerge[action.responseName][currTableName] = newOrigDataAfterMerge[action.responseName][currTableName].filter((prmItem) => {
                                return prmItem[action.queryEntityHierarchy.KeyField] > 0
                            })
                        }

                        if (lstRemoveRowsOfMissingKeys.length > 0) {
                            let lstRemoveRowKeys = lstRemoveRowsOfMissingKeys.filter((prmKey) => {
                                let outVal = false

                                let foundObj = lstCurrTabData.find((prmNewItem) => {
                                    return prmNewItem[action.queryEntityHierarchy.KeyField] == prmKey
                                })

                                outVal = !foundObj

                                return outVal
                            })

                            if (lstRemoveRowKeys.length > 0) {
                                newDataAfterMerge[action.responseName][currTableName] = newDataAfterMerge[action.responseName][currTableName].filter((prmItem) => {
                                    let outVal = !lstRemoveRowKeys.includes(prmItem[action.queryEntityHierarchy.KeyField].toString())

                                    return outVal
                                })

                                newOrigDataAfterMerge[action.responseName][currTableName] = newOrigDataAfterMerge[action.responseName][currTableName].filter((prmItem) => {
                                    let outVal = !lstRemoveRowKeys.includes(prmItem[action.queryEntityHierarchy.KeyField].toString())

                                    return outVal
                                })

                            }
                        }

                        // for (const currRow of lstCurrTabData) {
                        //     let currKey = currRow[action.queryEntityHierarchy.KeyField]
                        //
                        //     if (!!lstPrevData){
                        //         let prevDataRow = lstPrevData.find((prmItem) => {
                        //             return prmItem[action.queryEntityHierarchy.KeyField] == currKey
                        //         })
                        //
                        //         if (!!prevDataRow){
                        //             let prevDataRowIndex = lstPrevData.indexOf(prevDataRow)
                        //
                        //             if (prevDataRowIndex > -1) {
                        //                 lstPrevData.splice(prevDataRowIndex,1,currRow)
                        //             }
                        //         }
                        //     }
                        //
                        //     if (!!lstPrevOrigData){
                        //         let prevOrigDataRow = lstPrevOrigData.find((prmItem) => {
                        //             return prmItem[action.queryEntityHierarchy.KeyField] == currKey
                        //         })
                        //
                        //         if (!!prevOrigDataRow){
                        //             let prevOrigDataRowIndex = lstPrevOrigData.indexOf(prevOrigDataRow)
                        //
                        //             if (prevOrigDataRowIndex > -1) {
                        //                 lstPrevOrigData.splice(prevOrigDataRowIndex,1,currRow)
                        //             }
                        //         }
                        //     }
                        //
                        // }
                    }


                }
            }

            let newOrigData = dataUtils.updatePageDataStoreOriginalData(state, action.responseName, newDataAfterMerge[action.responseName])

            const outMergedObj = {
                ...state,
                data:  {...newDataAfterMerge},
                originalData: newOrigData, //{...newOrigDataAfterMerge},
            }

            executeApplyooComponentsFunction("onQueryDataChanged",{storeObj: outMergedObj, queryName: action.responseName})

            return outMergedObj

        case 'REFRESH_DATA_FOR_UI_COMPONENTS':
            for (const currQuaryName in state.dicResponseExtData) {
                executeApplyooComponentsFunction("onQueryDataChanged",{storeObj: state, queryName: currQuaryName})
            }
            return {...state}

        case 'SET_DATA':
            let currResponseName = ""
            let currHierarchyDataStructure = null
            let outObj = null

            if (!!action?.responseObj?.DicQueryEntityHierarchy) {
                if (Object.keys(action.responseObj.DicQueryEntityHierarchy).length > 0) {
                    currResponseName = Object.keys(action.responseObj.DicQueryEntityHierarchy)[0]
                    currHierarchyDataStructure = action.responseObj.DicQueryEntityHierarchy[currResponseName][0]
                }
                else {
                    currResponseName = Object.keys(action.responseObj.Data)[0]
                }

                let currDataObj = action.responseObj.Data[currResponseName]
                //let currHierarchyDataStructure = action.responseObj.DicQueryEntityHierarchy[currResponseName][0]

                let convertedObj = convertToHierarchyData(currDataObj,currHierarchyDataStructure,currResponseName);
                //let convertedObj = convertToHierarchyData(action.responseObj);
                let origData = cloneDeep(action.responseObj?.Data);  //dataUtils.clone(action.responseObj.Data); // {...action.responseObj.Data}

                let newData = {...state.data}
                let newOrigData = {...state.originalData}

                for (const currKey in convertedObj.convertedToHierarchyData) {
                    newData[currKey] = convertedObj.convertedToHierarchyData[currKey];
                }

                for (const currKey in origData) {
                    newOrigData[currKey] = origData[currKey];
                }


                const newGetDataResponseObj = {...state.getDataResponseObj}
                newGetDataResponseObj.DicQueryEntityHierarchy = {...newGetDataResponseObj.DicQueryEntityHierarchy,...action.responseObj.DicQueryEntityHierarchy}
                newGetDataResponseObj.DicRelatedDataRequests = {...newGetDataResponseObj.DicRelatedDataRequests,...action.responseObj.DicRelatedDataRequests}

                if (convertedObj.isNewRow){
                    const currPrimaryEntityName = Object.keys(convertedObj?.convertedToHierarchyData)[0]

                    let paramsNewEntityRow = {
                        //ProjectID: action.projectID,
                        QueryName: currPrimaryEntityName,
                        EntityName: newGetDataResponseObj.DicQueryEntityHierarchy[currPrimaryEntityName][0]["EntityName"],
                        DataConnectionCode: newGetDataResponseObj.DicQueryEntityHierarchy[currPrimaryEntityName][0]["DataConnectionCode"]
                    };

                    executeApplyooComponentsFunction("onSystemEvent_NewPrimaryEntityRow", paramsNewEntityRow)

                }

                let newDicResponseExtData = state.dicResponseExtData
                let currResponseExtData = state.dicResponseExtData[convertedObj.responseName]
                if (!!currResponseExtData){
                    if (convertedObj.primaryEntityID != currResponseExtData.primaryEntityID){
                        currResponseExtData.lstFiles = []
                        currResponseExtData.lstOriginalFiles = []
                    }
                }
                else {
                    currResponseExtData = {
                        primaryEntityID: convertedObj.primaryEntityID,
                        isNewRow: convertedObj.isNewRow,
                        responseName: convertedObj.responseName,
                        isDataLoaded: true,
                        lstOriginalFiles: [],
                        lstFiles: [],
                    }

                    newDicResponseExtData[convertedObj.responseName] = currResponseExtData
                }

                const newDicLastResponseObj = {...state.dicLastResponseObj}
                newDicLastResponseObj[currResponseName] = action.responseObj

                const newDicPagingByResponseObj= {...state.dicLastResponseObj}

                if (!newDicPagingByResponseObj[currResponseName]) {
                    newDicPagingByResponseObj[currResponseName] = {}
                }

                newDicPagingByResponseObj[currResponseName].PageNumber = action?.responseObj?.PageNumber || 0
                // newDicPagingByResponseObj[currResponseName] = {
                //     PageNumber: action?.responseObj?.PageNumber || 0,
                //     //PageSize: action?.responseObj?.PageSize || 0
                // }

                if (!newDicPagingByResponseObj[currResponseName].PageSize) {
                    newDicPagingByResponseObj[currResponseName].PageSize = action?.responseObj?.PageNumber || 0
                }

                // newOrigData[currResponseName] = cloneDeep(newData[currResponseName])

                newOrigData =  dataUtils.updatePageDataStoreOriginalData(state, currResponseName, newData[currResponseName])

                outObj = {
                    ...state, data: newData,
                    getDataResponseObj: newGetDataResponseObj, //action.responseObj,
                    originalData: newOrigData,

                    isNewRow: convertedObj.isNewRow,
                    primaryEntityID: convertedObj.primaryEntityID,
                    isDataLoaded: true,
                    dicResponseExtData: newDicResponseExtData,
                    dicLastResponseObj: newDicLastResponseObj,
                    dicPagingByResponseObj: newDicPagingByResponseObj,
                    //lstOriginalFiles: [],
                    //lstFiles: lstEntityFiles,
                }

                executeApplyooComponentsFunction("onQueryDataChanged",{storeObj: outObj, queryName: Object.keys(action.responseObj.DicQueryEntityHierarchy).join()})

            }
            else {
                outObj = {...state}
            }

            return outObj

        case 'SET_PAGE_BY_RESPONSE_NAME':
            outObj = {...state}
            if (!!action.responseName) {
                const newDicPagingByResponseObj= {...state.dicLastResponseObj}
                newDicPagingByResponseObj[action.responseName] = {
                    ...newDicPagingByResponseObj[action.responseName],
                    PageNumber: action.pageNumber || 0,
                    //PageSize: action.pageSize || 0,
                }

                if(!newDicPagingByResponseObj[action.responseName]?.PageSize
                    || !!action.pageSize) {
                    newDicPagingByResponseObj[action.responseName].PageSize = action.pageSize
                }

                outObj.dicLastResponseObj = newDicPagingByResponseObj
            }

            return outObj

        case 'SET_NEW_ENTITY_DEFAULTS_DATA':
            let newState = {...state, data: {...state.data,...action.data, primaryEntityID: 0, isNewRow:true}}

            const timerId2 = setTimeout(() => {
                executeApplyooComponentsFunction("onSystemEvent_AfterSetNewPrimaryEntityDefaults",action.data)
                clearTimeout(timerId2)
            }, 10)

            return newState

        case 'SET_NEW_ENTITY_KEY':
            let newState2 = {...state} //{...state, primaryEntityID: action.primaryEntityID, isNewRow: (action.primaryEntityID <= 0)}

            if (!!action.responseName && state.dicResponseExtData[action.responseName]){
                let newDicResponseExtData = state.dicResponseExtData
                let newResponseExtDataObj = state.dicResponseExtData[action.responseName]

                newResponseExtDataObj = {...newResponseExtDataObj, primaryEntityID: action.primaryEntityID, isNewRow: (action.primaryEntityID <= 0)}
                newDicResponseExtData[action.responseName] = newResponseExtDataObj
                newState2 = {...newState2,dicResponseExtData: newDicResponseExtData}
            }

            return newState2

        case 'SET_ELEMENT_DATA':
            //let data =cloneDeep(state.data);
            let data =state.data;
            
            // let data = JSON.parse(JSON.stringify(state.data));
            dataUtils.setNestedJsonValue(data, action.dataKey, action.value, true);
            //data[action.dataKey][action.elementKey] = action.data
            let params ={
                data: data,
                dataBindStr : action.dataKey,
            }

            const timerId3 = setTimeout(() => {
                if (params?.dataBindStr?.startsWith('Filters.')) {
                    executeApplyooComponentsFunction("dataFiltersChanged",data)
                    executeApplyooComponentsFunction("onElementDataChanged",params)
                }
                else {
                    executeApplyooComponentsFunction("onElementDataChanged",params)
                }

                clearTimeout(timerId3)
            }, 10)

            return {...state, data: data}

        case 'SET_FILTERS_DATA':
            //let data2 =cloneDeep(state.data);
            let data2 = state.data;
            for (const dataKey in action.dicFilters) {
                const filterObj = action.dicFilters[dataKey]
                dataUtils.setNestedJsonValue(data2, dataKey, filterObj.Value, true);
            }

            const timerId = setTimeout(() => {
                executeApplyooComponentsFunction("dataFiltersChanged",data2)
                clearTimeout(timerId)
            }, 10)

            return {...state, data: data2}

        case 'CLEAR_QUERY_DATA':
            let newState_clearData = {...state}

            if (!!newState_clearData.data[action.queryName]) {
                newState_clearData.data[action.queryName] = action.newDataObj

                if (!!newState_clearData.dicResponseExtData
                        && !!newState_clearData.dicResponseExtData[action.queryName]) {
                    newState_clearData.dicResponseExtData[action.queryName].lstFiles = []
                    newState_clearData.dicResponseExtData[action.queryName].lstOriginalFiles = []
                }
            }

            if (!!newState_clearData.data[action.queryName]) {
                newState_clearData.originalData[action.queryName] = action.newDataObj
            }

            return newState_clearData

        case 'DUPLICATE_QUERY_DATA':
            let dicEntityHierarchy = state.getDataResponseObj?.DicQueryEntityHierarchy;
            let tempSubEntityID = 0;
            let qryData = null;

            let originalData = state.originalData;
            originalData[action.queryName] = {};
            //return {...state, isNewRow: true, primaryEntityID: null, originalData: originalData};

            if (!!dicEntityHierarchy && !!dicEntityHierarchy[action.queryName]) {
                let lstQueryTablesInfo = dicEntityHierarchy[action.queryName];

                for (let ind01 = 0; ind01 < lstQueryTablesInfo.length; ind01++) {
                    let currQueryTableInfo = lstQueryTablesInfo[ind01];

                    if (!!currQueryTableInfo.QueryResponseObj.IsAllowSave) {
                        qryData = state.data[action.queryName];
                        let primaryEntityData = null;

                        if (qryData && !!qryData[currQueryTableInfo.EntityName]) {
                            primaryEntityData = qryData[currQueryTableInfo.EntityName];
                            primaryEntityData[currQueryTableInfo.KeyField] = 0;
                        }

                        if (currQueryTableInfo.QueryResponseObj?.LstChildren?.length > 0) {
                            for (let ind02 = 0; ind02 < currQueryTableInfo.QueryResponseObj.LstChildren.length; ind02++) {
                                let currSubEntity = currQueryTableInfo.QueryResponseObj.LstChildren[ind02];

                                if (currSubEntity.QueryResponseObj.IsAllowSave
                                    && !!primaryEntityData[currSubEntity.EntityName]) {
                                    let lstSubEntityData = primaryEntityData[currSubEntity.EntityName];

                                    if (!!lstSubEntityData && lstSubEntityData.length > 0) {
                                        for (let ind03 = 0; ind03 < lstSubEntityData.length; ind03++) {
                                            let currSubEntityRow = lstSubEntityData[ind03];
                                            currSubEntityRow[currSubEntity.KeyField] = --tempSubEntityID
                                            currSubEntityRow[currSubEntity.SubEntityKeyField] = 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (!!qryData) {
                let newDataObj = {...state.data};
                newDataObj[action.queryName] = qryData;

                return {...state, isNewRow: true, primaryEntityID: null, data: newDataObj,originalData: originalData}
            } else {
                return {...state}
            }

        case 'SET_ACTIONS':
            return {...state, lstActions: action.lstActions}
        case 'OPEN_MODEL':
            return {...state, lstModals: action.lstModals}

        case 'SET_FILES':
            let lstFilesWithoutRelatedElementGuidFiles = []
            // let lstFiles_SetFiles = []
            let newDicResponseExtData_SetFiles = {...state.dicResponseExtData}

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]) {

                let lstCurrStateFiles = newDicResponseExtData_SetFiles[action.responseName].lstFiles || [] //= action.lstFiles || []
                if (!!action.elementGuid) {
                    lstCurrStateFiles = lstCurrStateFiles.filter((prmItem) => prmItem.RelElementGuid != action.elementGuid)
                    newDicResponseExtData_SetFiles[action.responseName].lstFiles = mergeQueryFiles(action.responseName, lstCurrStateFiles,action.lstFiles, 'addOrUpdate')
                }
                else {
                    newDicResponseExtData_SetFiles[action.responseName].lstFiles = action.lstFiles || []
                }
            }

            // lstFiles_SetFiles = action.lstFiles
            // if (!!lstFiles_SetFiles && !!action.elementGuid){
            //     lstFilesWithoutRelatedElementGuidFiles =  lstFiles_SetFiles.filter((prmItem) => {
            //         return prmItem.RelElementGuid == action.elementGuid
            //     })
            // }

            // for (const currFile of action.lstFiles) {
            //     let fileAlreadyExist = (lstFiles_SetFiles.find((prmItem) => prmItem.RuntimeToken == currFile.RuntimeToken))
            //     if (!!currFile.RuntimeToken && !fileAlreadyExist){
            //         lstFiles_SetFiles.push(currFile)
            //     }
            // }

            // if (!!action.responseName
            //     && state.dicResponseExtData[action.responseName]){
            //     newDicResponseExtData_SetFiles[action.responseName].lstFiles = lstFiles_SetFiles //state.dicResponseExtData[action.responseName].lstFiles
            // }

            return {...state, dicResponseExtData: newDicResponseExtData_SetFiles}
            //return {...state, lstFiles: action.lstFiles}

        case 'SET_SINGLE_FILE':
            let lstFiles_SetSingleFile = []
            let newDicResponseExtData_SetSingleFile = {...state.dicResponseExtData}

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]){
                lstFiles_SetSingleFile = state.dicResponseExtData[action.responseName].lstFiles || []
            }

            if(lstFiles_SetSingleFile?.find((prmItem) => prmItem?.RelElementGuid == action.elementGuid)){
                lstFiles_SetSingleFile = lstFiles_SetSingleFile?.filter((prmItem) => prmItem?.RelElementGuid != action.elementGuid)
            }

            if(!!action.lstFiles[0]){
                lstFiles_SetSingleFile.push(action.lstFiles[0])
            }

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]){
                newDicResponseExtData_SetSingleFile[action.responseName].lstFiles = lstFiles_SetSingleFile //state.dicResponseExtData[action.responseName].lstFiles
            }

            return {...state,dicResponseExtData: newDicResponseExtData_SetSingleFile}


        case 'SET_FILES_ORIGINAL_STATE':
            let lstOriginalFilesWithoutRelatedElementGuidFiles = []
            let lstFiles_SetOriginalFiles = []
            let newDicResponseExtData = {...state.dicResponseExtData}

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]){

                let lstMergedFiles = mergeQueryFiles(action.responseName, state.dicResponseExtData[action.responseName].lstFiles,action.lstFiles, 'addOrUpdate')

                lstFiles_SetOriginalFiles = state.dicResponseExtData[action.responseName].lstFiles || []
                newDicResponseExtData[action.responseName].lstOriginalFiles = lstMergedFiles.filter((prmItem) => prmItem.ID > 0) //cloneDeep(action.lstFiles)
                newDicResponseExtData[action.responseName].lstFiles = lstMergedFiles //cloneDeep(action.lstFiles)
            }

            return {...state, dicResponseExtData: newDicResponseExtData}

        case 'CLEAR_ORIGINAL_FILES_STATE':
            // let lstFiles_SetOriginalFilesState = []
            let newDicResponseExtData_SetOriginalFilesState = {...state.dicResponseExtData}

            // let newDicResponseExtData = {...state.dicResponseExtData}

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]){
                lstFiles_SetOriginalFiles = state.dicResponseExtData[action.responseName].lstFiles || []
                newDicResponseExtData_SetOriginalFilesState[action.responseName].lstOriginalFiles = []
                newDicResponseExtData_SetOriginalFilesState[action.responseName].lstFiles = []
            }

            // if (!!action.responseName
            //     && state.dicResponseExtData[action.responseName]){
            //     // lstFiles_SetOriginalFilesState = []
            //     // let currLstOriginalFiles = newDicResponseExtData_SetOriginalFilesState[action.responseName].lstOriginalFiles
            //     //
            //     // let currLstFiles = cloneDeep(action.lstFiles)
            //     //
            //     // if (!!action.isClearCurrentFilesState) {
            //     //     currLstFiles = []
            //     // }
            //
            //     newDicResponseExtData_SetOriginalFilesState[action.responseName].lstOriginalFiles = [] //[...currLstOriginalFiles ,...currLstFiles ]
            //
            //     //newDicResponseExtData_SetOriginalFilesState[action.responseName].lstFiles = newDicResponseExtData_SetOriginalFilesState[action.responseName].lstOriginalFiles
            // }

            return {...state, dicResponseExtData: newDicResponseExtData_SetOriginalFilesState}

        case 'SET_SINGLE_FILES_ORIGINAL_STATE':
            let lstFiles_SetSingleOriginalFiles = []
            let newDicResponseExtData_SetSingleOriginalFiles = {...state.dicResponseExtData}

            if (!!action.responseName
                && state.dicResponseExtData[action.responseName]){
                lstFiles_SetSingleOriginalFiles = state.dicResponseExtData[action.responseName].lstFiles || []
                let currLstFiles = cloneDeep(action.lstFiles)
                let currLstOriginalFiles = newDicResponseExtData_SetSingleOriginalFiles[action.responseName].lstOriginalFiles

                let lstMergedFiles = mergeQueryFiles(action.responseName, state.dicResponseExtData[action.responseName].lstFiles,action.lstFiles, 'addOrUpdate')
                newDicResponseExtData_SetSingleOriginalFiles[action.responseName].lstOriginalFiles = lstMergedFiles.filter((prmItem) => prmItem.ID > 0) // [...currLstOriginalFiles ,...currLstFiles ]
                newDicResponseExtData_SetSingleOriginalFiles[action.responseName].lstFiles = lstMergedFiles //newDicResponseExtData_SetSingleOriginalFiles[action.responseName].lstOriginalFiles
            }

            return {...state, lstOriginalFiles: lstFiles_SetSingleOriginalFiles,dicResponseExtData: newDicResponseExtData_SetSingleOriginalFiles}

        case 'CLEAR_VALIDATION_ERRORS':
            return {
                ...state,
                lstValidationErrors: [],
                dicValidationErrorsByElement: {}
            }

        case 'SET_CUSTOM_FLAG':
            let newState_CustomFlag = {...state}
            dataUtils.setNestedJsonValue(newState_CustomFlag.dicCustomFlags, action.customFlagName, action.customFlagValue, true)
            // newState_CustomFlag.dicCustomFlags[action.customFlagName] = action.customFlagValue

            return newState_CustomFlag

        case 'SET_ORIGINAL_QUERY_DATA':
            let newOrigQueryState = {...state}

            if (!!action.responseName) {
                newOrigQueryState.data[action.responseName] = newOrigQueryState.originalData[action.responseName]
                newOrigQueryState.lstFiles = newOrigQueryState.lstOriginalFiles
            }

            // newOrigQueryState.data
            //
            // let newOrigData = updateOriginalData(newOrigQueryState, action.responseName, newOrigQueryState.data)
            // newOrigQueryState.originalData = newOrigData
            //newOrigQueryState.originalData[action.responseName] = cloneDeep(newOrigQueryState.data[action.responseName])
            executeApplyooComponentsFunction("onQueryDataChanged",{storeObj: newOrigQueryState, queryName: action.responseName})

            return newOrigQueryState

        case 'CLEAR_ORIGINAL_QUERY_DATA':
            let newOrigState = {...state}

            newOrigState.originalData[action.responseName] = {}
            newOrigState.dicResponseExtData[action.responseName] = {
                lstOriginalFiles: [],
                lstFiles: []
            }

            return newOrigState

        case 'SET_VALIDATION_ERRORS':
            let dicValidationErrorsByElement = groupValidationErrorsByElement(action.lstValidationErrors);

            executeApplyooComponentsFunction("onValidationErrorsChanged",{queryName: action.queryName, lstValidationErrors: action.lstValidationErrors})

            return {
                ...state,
                lstValidationErrors: action.lstValidationErrors,
                dicValidationErrorsByElement: dicValidationErrorsByElement
            }


    
        default:
            return state
    }

}

// export default store_PageData
